import React from 'react';
import type { Item } from '../types';
import { potionRestoresHealth, stackPotionItems } from '../utils/itemStats';

type DeathScreenProps = {
  name: string;
  items?: Item[] | null;
  onDrink?: (characterItemId: number) => void;
};

export function DeathScreen({ name, items, onDrink }: DeathScreenProps) {
  const healingStacks = stackPotionItems(items).filter(({ item }) => potionRestoresHealth(item));

  return (
    <div className="death-screen" role="status" aria-live="assertive" aria-label={`${name} ist besiegt`}>
      <div className="death-screen-panel">
        <div className="death-screen-skull" aria-hidden>☠</div>
        <p className="death-screen-kicker">Gefallen</p>
        <h2 className="death-screen-title">Besiegt</h2>
        <div className="death-screen-ornament" aria-hidden>═══════ ✦ ═══════</div>
        <p className="death-screen-name">{name}</p>
        <p className="death-screen-copy">Dein Held liegt am Boden. Der Spielleiter entscheidet über dein Schicksal.</p>
        {healingStacks.length > 0 && (
          <div className="death-screen-hope">
            <p className="death-screen-hope-label">Letzte Hoffnung</p>
            {healingStacks.map(({ item, count }) => (
              <button
                key={item.character_item_id || item.id}
                type="button"
                className="medieval-button death-screen-drink"
                disabled={!item.character_item_id || !onDrink}
                onClick={() => item.character_item_id && onDrink?.(item.character_item_id)}
              >
                {item.name} trinken{count > 1 ? ` ×${count}` : ''}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
